import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {

  transform(items: string[], value: string, keySensitive: boolean = false): string[] {
    return items.filter(i => keySensitive ? i.includes(value) : i.toLowerCase().includes(value.toLowerCase()));
  }

}
